const _ = require('lodash');
const Edition = require('core/src/edition').default;
const {i18next} = require ('core/src/language');
const Err = require("utils/src/error");
Edition.setBuildFeature(Edition.Feature.MULTI_LINGUAL, true);

const Function = require('core/src/function');

const logger = require('core/src/log').instance("function/load-translations");

const LoadTranslations = Function.extend(Function, 'LoadTranslations');

LoadTranslations.prototype.execute = function (...args) {
	if(!Edition.hasFeature(Edition.Feature.MULTI_LINGUAL)) {
	console.error('Edition.Feature.MULTI_LINGUAL');
		const error = Edition.functionNotAvailableError('language');
		this.error(error);
		throw error;
	}

	return Function.prototype.execute.call(this, ...args);
};

LoadTranslations.prototype.onInit = function(dependencies) {

	this.setParameters({
		'$languages': undefined,
		'$namespaces': undefined
	});
	this.setModelValidation({
		languages: 'isArray',
		namespaces: ['isArray', { default: [] }]
	});
};

LoadTranslations.prototype.onExecute = async function() {
	const languages = this.readModel('languages');
	const namespaces = this.readModel('namespaces');
 	if (!languages || languages.length === 0) {
 		logger.error('The languages are not defined to load');
 		this.error(error);
		throw error;
 	}
	const currentlyLoadedLanguages = i18next.languages || [];
	const newLanguagesToLoad = _.difference(languages, currentlyLoadedLanguages);

	if (newLanguagesToLoad.length === 0) {
   		logger.log('There are no new langauges to load.');
   		return true;
   	}

	try {
		await i18next.reloadResources(newLanguagesToLoad, namespaces);

		this.executeTriggers({ type: 'translationsLoaded', languages: newLanguagesToLoad, namespaces});
		return true;
	} catch (error) {
		logger.error('Failed to load translations.', error);
		this.error(error);
		return false;
	}
};

module.exports = LoadTranslations;